import { useState, useMemo } from "react";
import { z } from "zod";
import { ListBeaconFiltersValidation } from "@/lib/api/fund";

export function useBeaconFilters() {
  const currentYear = new Date().getFullYear();
  const [selectedYears, setSelectedYears] = useState<number[]>([]);
  const [selectedCustomerId, setSelectedCustomerId] = useState<string | undefined>();
  const [selectedEmployeeId, setSelectedEmployeeId] = useState<string | undefined>();

  const yearOptions = Array.from({ length: 10 }, (_, i) => ({
    value: String(currentYear - i),
    label: String(currentYear - i),
  }));

  const filters = useMemo((): z.infer<typeof ListBeaconFiltersValidation> => ({
    years: selectedYears,
    customer_id: selectedCustomerId,
    employee_id: selectedEmployeeId,
  }), [selectedYears, selectedCustomerId, selectedEmployeeId]);

  return {
    selectedYears,
    setSelectedYears,
    selectedCustomerId,
    setSelectedCustomerId,
    selectedEmployeeId,
    setSelectedEmployeeId,
    yearOptions,
    filters,
    currentYear,
  };
}